import { Component, OnInit, ErrorHandler } from '@angular/core';
import { RegistrationService } from '../../../registration.service';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-station-grid',
  templateUrl: './station-grid.component.html',
  styleUrls: ['./station-grid.component.css']
})
export class StationGridComponent implements OnInit {
  maintitle="Stations";
  title = "View Stations";
  stationList: any=[];
  totalItems: number;
  itemsPerPage: number=5 ;
  currentPage: number=1;
   t:any={};
  constructor(private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) { }

  ngOnInit() {
    this.GetAllStationsForMasters(this.itemsPerPage, 1);
  }

  SetUrl(Station_Id:any,mode:any)
  {
    localStorage.setItem('Station_Id',Station_Id);
    localStorage.setItem('mode', mode);
  }
  
  pageChanged(pageNumber: number) {
  
      this.GetAllStationsForMasters(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
   
      this.GetAllStationsForMasters(this.itemsPerPage, pageNo);
  }


  GetAllStationsForMasters(itemsPerPage: number, pageNo: number) {
    
       this.userService.getAllstations(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.stationList = data.stationList;
          console.log(data);
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

//Delete
  DeleteStation(Station_Id:any)
  {
    
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deleteStation(Station_Id).subscribe(
          (data:any) => {
            swal('','Station has been Deleted!','success');
            this.GetAllStationsForMasters(this.itemsPerPage, 1);
            // this.s.SearchText = "";
            // this.s.SearchCriteria = "";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.handleError(error);
          });
      }
    })  
  }


}



// WEBPACK FOOTER //
// ./src/app/Masters/stations/station-grid/station-grid.component.ts